import { TagListColored } from "./Colored";
import { TagListPlain } from "./Plain";

export { TagListColored, TagListPlain };
